import {useState} from "react";
import {useLocation} from "react-router";
import {apiLink} from "@web2/ap-api-routes";
import {appendQueryString, parseSearch} from "@web2/ap-request";
import {Button} from "@web2/button";

import {downloadFileAuthorized} from "../../app/utils/authorized_request";

interface IProps {
    className?: string;
    size: "lg" | "sm";
}

export const DownloadApplicationsButton = (props: IProps) => {
    // endpoint `/application/xlsx/` uses the same query params as `/application/`,
    // so we expect downloaded file contents to be an exact match to results presented in Applications view
    const location = useLocation();
    const downloadLink = appendQueryString(apiLink.applications.xlsx({})(null), parseSearch(location.search));
    const [isLoading, setIsLoading] = useState(false);

    const onClick = async () => {
        setIsLoading(true);
        await downloadFileAuthorized(downloadLink, "xlsx");
        setIsLoading(false);
    };

    return (
        <Button type="button" className={props.className} size={props.size} onClick={onClick} disabled={isLoading}>
            EKSPORT
        </Button>
    );
};
